


export enum EnumsOptions
{ 
	GoCreditLogin = "GoCreditLogin",
	GoCreditPassword = "GoCreditPassword",
	GoCreditPaymentPage = "GoCreditPaymentPage"


}
export enum BillLineTypes
{ 
	Recurring = "Recurring",
	OneTime = "OneTime",
	ByConsumption = "ByConsumption"


}
export enum RegistarationStatuses
{ 
	AddedOnly = "AddedOnly",
	PaymentConfirmed = "PaymentConfirmed",
	SBODocsCreated = "SBODocsCreated"


}
export enum EnumsCityType
{ 
	Yeshuv = "Yeshuv",
	Kibbutz = "Kibbutz"


}

